import { render } from "./App.vue?vue&type=template&id=5adbe0cd&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5adbe0cd&lang=css"
import "./App.vue?vue&type=style&index=1&id=5adbe0cd&scoped=true&lang=css"

import exportComponent from "/Users/williamconnell/Desktop/Minilogue Project/xdpatch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adbe0cd"]])

export default __exports__